import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { InterestEntryFormData } from "@/formTypes/InterestEntryDataType";

export type InterestEntryDataType = Partial<ApiSchema["InterestEntry"]["type"] & InterestEntryFormData>;
class Api extends GenericModelApi<"InterestEntry", InterestEntryDataType> {

    async fetchAllByRecibe(recibeId: string): Promise<FetchResponse<InterestEntryDataType>> {
        const fetchFunction = ApiClient.models[this.modelName].listInterestEntryByRecibeId;

        const { data, errors, nextToken: nt } = await fetchFunction({
            recibeId: recibeId
        }, {
            limit: 1000
        });

        if (errors) {
            throw new ApiError("Error al obtener los intereses por recibo", "API_ERROR", errors);
        }

        return { items: data };
    }

}
export const InterestEntryApi = new Api("InterestEntry", "numero", "DESC", "numero");